import React, {
  useState,
  useMemo,
  useCallback,
} from 'react'
import { getFromNowAsText, getFormattedDate } from '../../helpers/timeHelper'
import GoogleMapWrapperForDetailView from './GoogleMapWrapperForDetailView'
import { firstMapPinIcon } from '../../icons'
import './DetailMamorioMap.css'

type Props = {
  date: string
  detectionLogs: IDetectionLog[]
  updateMamorioLogs: (arg: string) => void
  downloadLogs: () => void
  blueprints: IBlueprint[]
  pinIconSrc?: string // オプション: マップピンのアイコンソース
  detailHistoryEnabled?: boolean
}

const DetailMamorioMap = ({
  date,
  detectionLogs,
  updateMamorioLogs,
  downloadLogs,
  blueprints,
  pinIconSrc = firstMapPinIcon,
  detailHistoryEnabled = false,
}: Props) => {
  const [sliderValue, setSliderValue] = useState(Math.max(...detectionLogs.map((log) => new Date(log.detected_at).getTime())))
  const { minTimestamp, maxTimestamp } = useMemo(() => {
    const timestamps = detectionLogs.map((log) => new Date(log.detected_at).getTime())
    const min = Math.min(...timestamps)
    const max = Math.max(...timestamps)
    return { minTimestamp: min, maxTimestamp: max }
  }, [detectionLogs])
  const handleSliderChange = (event:any) => {
    setSliderValue(event.target.value)
  }

  const sliderLabel = useMemo(() => {
    const selectedTimestamp = detectionLogs.find((log) => new Date(log.detected_at).getTime() <= sliderValue)
    return selectedTimestamp ? getFromNowAsText(selectedTimestamp.detected_at) : ''
  }, [detectionLogs, sliderValue])

  const filteredDetectionLogs = useMemo(() => detectionLogs.filter((log) => new Date(log.detected_at).getTime() <= sliderValue), [detectionLogs, sliderValue])

  const sliderPercentage = useCallback(() => Math.min(((sliderValue - minTimestamp) / (maxTimestamp - minTimestamp)) * 100, 88), [sliderValue, minTimestamp, maxTimestamp])

  return (
    <div className="map-view detail-mamorio-map">
      <div className="map" style={{ height: '360px', marginBottom: '20px' }}>
        <GoogleMapWrapperForDetailView
          containerStyle={{ height: '360px' }}
          zoom={18}
          detectionLogs={filteredDetectionLogs}
          mapPinIconSrc={pinIconSrc}
          blueprints={blueprints}
        />
      </div>
      <div className="slider-container" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
        <input
          type="range"
          min={minTimestamp}
          max={maxTimestamp}
          value={sliderValue}
          onChange={handleSliderChange}
          style={{ maxWidth: '100%', padding: '0px' }}
          className="time-slider"
        />
        <div className="slider-label" style={{ marginLeft: `calc(${sliderPercentage()}%)` }}>
          {sliderLabel}
        </div>
      </div>
      {
        detailHistoryEnabled && (
          <div className="date-conatiner">
            <label>日付</label>
            <input className="date" defaultValue={date} type="date" onChange={(e) => updateMamorioLogs(e.target.value)} />
            {
              detectionLogs.length > 1 || date === getFormattedDate(detectionLogs[0]?.detected_at, 'YYYY-MM-DD') ? (
                <button type="button" className="btn btn-primary btn-sm" onClick={downloadLogs}>
                  CSVをダウンロード(
                  {detectionLogs.length}
                  件)
                </button>
              ) : (
                <button type="button" disabled className="btn btn-primary btn-sm">
                  ログがありません
                </button>
              )
            }
          </div>
        )
      }
    </div>
  )
}

export default DetailMamorioMap
